import React from 'react';
import playstore from '../../assets/google.png';
import appstore from '../../assets/apple.png';
import phone from '../../assets/lady.png';
import './header.css';

const Header = () => (
  <div className="gpt3__header section__padding" id="home">
    <div className="gpt3__header-content">
      <h1 className="gradient__text">Investment Has Never Been Easier</h1>
      <p>Yet bed any for travelling assistance indulgence unpleasing. Not thoughts all exercise blessing. Indulgence way everything joy alteration boisterous the attachment. Party we years to order allow asked of.</p>

      <div className="gpt3__header-content__store">
     
      <div className="gpt3__header-content__wrapper">
      <img src={playstore} />
        <div>
          <p>Get it on</p>
          <p className="store__name">Google Play</p>
        </div>
      </div>

      <div className="gpt3__header-content__wrapper">
        
      <img src={appstore} />
        <div>
          <p>Download from</p>
          <p className="store__name">Apple Store</p>
        </div>
      </div> 

      </div>

      {/* <div className="gpt3__header-content__people">
        <img src={people} />
        <p>1,600 people requested access a visit in last 24 hours</p>
      </div> */}
    </div>

    <div className="gpt3__header-image">
      <img src={phone} />
    </div>
  </div>
);

export default Header;
